const tanker = [
  // ── TANKER BASICS ──────────────────────────────────────────────────────────
  {
    id: "tn001",
    question: "A Tank Vehicle (N) endorsement is required for drivers who operate:",
    options: [
      "Any vehicle with a fuel tank over 50 gallons",
      "Vehicles designed to transport liquid or liquefied gas in a permanently attached or portable cargo tank of 119 gallons or more",
      "Only propane delivery trucks",
      "Any truck that hauls water",
    ],
    answer: 1,
    explanation: "The N endorsement is required for vehicles with a cargo tank rated at 119 gallons or more (liquids) or 1,000 lbs water capacity (gases). This applies whether the tank is permanently attached or a portable tank.",
  },
  {
    id: "tn002",
    question: "Tank vehicles are more dangerous than most other CMVs primarily because:",
    options: [
      "They are harder to see in mirrors",
      "Liquid cargo creates a high center of gravity and liquid surge that can cause rollovers and loss of control",
      "The tanks are slippery when wet",
      "Tank vehicles have no ABS",
    ],
    answer: 1,
    explanation: "Liquid cargo sits high off the ground, raising the center of gravity. Additionally, liquid surges when braking or turning, shifting weight and making the vehicle unstable.",
  },
  // ── LIQUID SURGE ───────────────────────────────────────────────────────────
  {
    id: "tn003",
    question: "What is 'liquid surge' (also called 'surge') in a tank vehicle?",
    options: [
      "The overflow of liquid from an overfilled tank",
      "The forward and backward movement of liquid in a partially filled tank during acceleration and braking",
      "The vibration of liquid at highway speeds",
      "The pressure increase in a tank at high temperatures",
    ],
    answer: 1,
    explanation: "Liquid surge is the forward-backward (or side-to-side) movement of liquid in a partially filled tank. When you brake, liquid continues forward — pushing the vehicle. This extends stopping distances significantly.",
  },
  {
    id: "tn004",
    question: "Liquid surge is most dangerous when a tank is:",
    options: [
      "Completely full",
      "Completely empty",
      "Partially filled (especially 50–75% full), because the liquid has maximum room to move",
      "Filled with a thick viscous liquid",
    ],
    answer: 2,
    explanation: "Partially filled tanks allow the most liquid movement. A full tank has no room for surge; an empty tank has no liquid. The 50–75% range is typically the most dangerous for surge.",
  },
  {
    id: "tn005",
    question: "How does forward liquid surge affect braking?",
    options: [
      "It helps the vehicle stop faster",
      "When you brake, forward-moving liquid continues to push the vehicle forward, increasing stopping distance and potentially overriding the brakes",
      "It has no effect on braking",
      "It only affects steering",
    ],
    answer: 1,
    explanation: "Forward surge can actually push the vehicle into a moving tank even while brakes are applied. Tanker drivers must anticipate stops much earlier and brake more gradually than with solid cargo.",
  },
  {
    id: "tn006",
    question: "To manage liquid surge when braking, tanker drivers should:",
    options: [
      "Brake hard and suddenly to stop before the surge catches up",
      "Brake early and gradually — use light, steady pressure to allow the liquid to slow with the vehicle",
      "Use only the engine brake",
      "Apply and release brakes rapidly (fan the brakes)",
    ],
    answer: 1,
    explanation: "Gradual, early braking reduces the severity of surge. Hard, sudden braking allows liquid to build up forward momentum that the brakes cannot overcome.",
  },
  // ── BAFFLED AND UNBAFFLED TANKS ─────────────────────────────────────────────
  {
    id: "tn007",
    question: "What is a 'baffled' tank?",
    options: [
      "A tank with double walls for insulation",
      "A tank with interior bulkheads (baffles) that allow liquid to flow from compartment to compartment but reduce front-to-back surge",
      "A tank designed to carry multiple liquid types",
      "A tank with a pressurized top section",
    ],
    answer: 1,
    explanation: "Baffles are bulkheads with holes that let liquid flow through but slow front-to-back movement. They reduce (not eliminate) surge but do not reduce side-to-side surge.",
  },
  {
    id: "tn008",
    question: "An 'unbaffled' (smooth-bore) tank:",
    options: [
      "Is the safest type of tanker",
      "Has no internal dividers — liquid can surge fully from end to end and side to side, making it the most challenging to drive",
      "Is used only for dry bulk materials",
      "Is only used for pressurized gas",
    ],
    answer: 1,
    explanation: "Smooth-bore tanks have no baffles. The entire liquid load can move freely. These are most commonly used for food-grade liquids (to ease cleaning) and present the greatest surge challenge.",
  },
  {
    id: "tn009",
    question: "Baffles in a tank vehicle DO NOT prevent:",
    options: [
      "Front-to-back liquid surge",
      "Side-to-side liquid surge, which occurs in turns and can contribute to rollover",
      "Liquid from spilling during a crash",
      "Pressure buildup in the tank",
    ],
    answer: 1,
    explanation: "Baffles only control front-to-back surge. They do not prevent side-to-side surge in turns, which can shift the center of gravity and cause rollovers.",
  },
  // ── HIGH CENTER OF GRAVITY ──────────────────────────────────────────────────
  {
    id: "tn010",
    question: "Why do tank vehicles have a higher risk of rollover than most other CMVs?",
    options: [
      "Because they are longer",
      "Because the center of gravity is high (liquid is above the axles) and liquid surge shifts weight unpredictably",
      "Because they use older brake technology",
      "Because they are wider",
    ],
    answer: 1,
    explanation: "Tank vehicles carry liquid high above the road surface. This high center of gravity, combined with surge shifting weight in corners, dramatically increases rollover risk compared to flat-bed loads or enclosed box trailers.",
  },
  {
    id: "tn011",
    question: "When taking a curve or freeway ramp in a tanker, you should:",
    options: [
      "Maintain the posted speed limit for cars",
      "Slow significantly below the posted speed — ramp speeds for cars are often far too fast for loaded tankers",
      "Accelerate slightly to stabilize the vehicle",
      "The posted truck speed limit is always safe for tankers",
    ],
    answer: 1,
    explanation: "Posted speed limits — even truck advisory speeds — may be far too fast for a loaded tanker in a curve. The combination of high center of gravity and surge can roll a tanker at speeds safe for a car.",
  },
  // ── OUTAGE (ULLAGE) ────────────────────────────────────────────────────────
  {
    id: "tn012",
    question: "What is 'outage' (or 'ullage') in tanker operations?",
    options: [
      "A leak in the tank",
      "The empty space left at the top of the tank when loading liquid to allow for expansion",
      "The weight of empty tank tare",
      "The distance from the ground to the tank bottom",
    ],
    answer: 1,
    explanation: "Outage is the space left unfilled in a liquid tank to allow for thermal expansion of the liquid. Overfilling without outage can cause the tank to rupture or vent when the liquid expands.",
  },
  {
    id: "tn013",
    question: "Different liquids require different amounts of outage. Which type of liquid requires MORE outage space?",
    options: [
      "Cold water",
      "Liquids that expand significantly with temperature — such as gasoline — require more outage than denser liquids like water",
      "Thick oils",
      "Cold diesel fuel",
    ],
    answer: 1,
    explanation: "Liquids with high thermal expansion (like gasoline) need more outage space. Filling to 100% capacity can cause the tank to pressurize and vent or rupture as temperature rises.",
  },
  // ── TANK VEHICLE INSPECTION ─────────────────────────────────────────────────
  {
    id: "tn014",
    question: "During a pre-trip inspection of a tank vehicle, what unique items should be checked?",
    options: [
      "Only tire pressure",
      "Manholes, vents, and outage openings are closed and secure; no leaks from tank body, piping, or valves; emergency shutoff valves operable; tank supports and baffles secure",
      "Only the pump equipment",
      "Only that the tank is at the correct level",
    ],
    answer: 1,
    explanation: "Tank-specific inspection includes: manhole covers secured, vents and caps in good condition, all valves closed and leak-free, emergency shutoffs operational, and tank body free of cracks or dents.",
  },
  {
    id: "tn015",
    question: "What should you check regarding the manhole covers on a tanker?",
    options: [
      "Only that they are present",
      "That they are securely closed and latched, the seals (gaskets) are in good condition, and they are not damaged or missing hardware",
      "Only that they are painted the correct color",
      "That they open easily",
    ],
    answer: 1,
    explanation: "Manhole covers must be properly latched and sealed. A loose or faulty cover can allow liquid to spill during transit, which may be hazardous and causes loss of cargo.",
  },
  {
    id: "tn016",
    question: "Before loading a liquid tank, you should check:",
    options: [
      "Only the fuel level in the tractor",
      "All valves are in the correct position (loading/unloading valves closed if not in use), all outlets are closed and capped, and the tank is clear to receive the product",
      "Only that the odometer works",
      "Only that the scale is nearby",
    ],
    answer: 1,
    explanation: "Pre-loading checks prevent product from leaking, mixing with wrong products, or loading into the wrong compartment. Verify all valves are set correctly before loading begins.",
  },
  // ── EMERGENCY EQUIPMENT ON TANKERS ─────────────────────────────────────────
  {
    id: "tn017",
    question: "An emergency shutoff valve on a tanker is used to:",
    options: [
      "Stop the tractor engine in an emergency",
      "Stop the flow of liquid from the tank in an event such as a hose rupture or fire, preventing further product release",
      "Shut off air pressure to the brakes",
      "Lock the trailer to the tractor",
    ],
    answer: 1,
    explanation: "Emergency shutoff valves can be closed remotely to stop the flow of product. In a fire or hose rupture, closing this valve can prevent massive product release and reduce the hazard.",
  },
  {
    id: "tn018",
    question: "The emergency shutoff on a tank vehicle should be tested:",
    options: [
      "Never — it may cause product release",
      "During the pre-trip inspection to verify it operates correctly",
      "Only at the terminal before loading",
      "Only during annual inspections",
    ],
    answer: 1,
    explanation: "Verify the emergency shutoff operates properly before every trip. A stuck or inoperable shutoff valve cannot stop product flow in an emergency.",
  },
  // ── DRIVING TECHNIQUES FOR TANKERS ─────────────────────────────────────────
  {
    id: "tn019",
    question: "Why must you be especially careful when starting from a stop in a tanker?",
    options: [
      "The engine needs more warm-up time",
      "Forward acceleration can cause the liquid to surge to the rear, reducing traction on the drive wheels and making the tractor hard to control",
      "The brakes take longer to engage",
      "The fuel consumption is higher",
    ],
    answer: 1,
    explanation: "When accelerating, liquid in a partial tank surges backward, shifting weight to the rear. This can reduce drive wheel traction and cause the rear to slide or spin.",
  },
  {
    id: "tn020",
    question: "When approaching a stop sign or red light with a loaded tanker, you should:",
    options: [
      "Brake at the same distance as any other truck",
      "Begin braking much earlier than normal — surge will extend your stopping distance significantly beyond what a solid load would require",
      "Speed up slightly before braking to compress the liquid",
      "Use engine brake only",
    ],
    answer: 1,
    explanation: "Forward surge during braking pushes the vehicle forward even while brakes are applied. Start braking far earlier than you would for solid cargo.",
  },
  {
    id: "tn021",
    question: "Tanker drivers should avoid sudden lane changes because:",
    options: [
      "It is illegal in most states",
      "Side-to-side surge can shift weight dramatically in a rapid lane change, potentially rolling the tanker",
      "The tank valves may open",
      "The tractor's steering is less responsive",
    ],
    answer: 1,
    explanation: "Sudden lateral movements cause side-to-side surge. This weight shift raises the center of gravity on one side and can flip the vehicle over.",
  },
  {
    id: "tn022",
    question: "When driving a tanker in rain or on slippery roads, you should:",
    options: [
      "Drive at the same speed as other traffic",
      "Significantly reduce speed — liquid surge combined with reduced traction dramatically increases the risk of jackknife or rollover",
      "Fill the tank to eliminate surge",
      "Use the trailer brake only to avoid jackknife",
    ],
    answer: 1,
    explanation: "Slippery roads reduce traction while surge continues to shift weight. The combination can cause loss of control much more easily than on dry pavement.",
  },
  // ── TANKER WEIGHT AND LOADING ───────────────────────────────────────────────
  {
    id: "tn023",
    question: "Liquid cargo weight is calculated based on:",
    options: [
      "Volume in gallons only",
      "Weight per gallon of the specific liquid (density) multiplied by the number of gallons",
      "The total tank capacity in gallons",
      "The tare weight of the tank",
    ],
    answer: 1,
    explanation: "Different liquids have different densities. Gasoline weighs about 6.1 lbs/gal, water weighs 8.3 lbs/gal, and some chemicals are even heavier. You must know the density to avoid overloading.",
  },
  {
    id: "tn024",
    question: "When pulling multiple tanker trailers (tank doubles), the surge effects are:",
    options: [
      "Reduced because the trailers balance each other",
      "Amplified — multiple liquid loads surge independently and the rear trailer's surge is magnified by the crack-the-whip effect",
      "The same as a single tanker",
      "Eliminated if the tanks are fully loaded",
    ],
    answer: 1,
    explanation: "In tank doubles or triples, each tank surges independently. The rear trailer also experiences rearward amplification from the combination vehicle's dynamics, greatly increasing instability.",
  },
  // ── SPECIAL TANKER TYPES ────────────────────────────────────────────────────
  {
    id: "tn025",
    question: "A 'pressurized' tank vehicle is used for:",
    options: [
      "Carrying liquid food products under sanitary conditions",
      "Transporting liquefied gases (such as propane, anhydrous ammonia, chlorine) that are stored as liquids under pressure",
      "Pumping concrete",
      "Carrying dry bulk materials under air pressure",
    ],
    answer: 1,
    explanation: "Pressurized tanks carry materials that are gases at normal temperature and pressure but are stored as liquids under pressure. These require special handling, inspection, and pressure-rating compliance.",
  },
  {
    id: "tn026",
    question: "A 'cryogenic' liquid tanker carries:",
    options: [
      "Very cold frozen food",
      "Gases liquefied by extreme refrigeration at very low temperatures — such as liquid nitrogen, liquid oxygen, or liquid natural gas",
      "Dry ice shipments",
      "Refrigerated food products",
    ],
    answer: 1,
    explanation: "Cryogenic tankers carry gases cooled to very low temperatures until they become liquid. Liquid nitrogen (-321°F), liquid oxygen (-297°F), and LNG require specially insulated tanks and special handling.",
  },
  {
    id: "tn027",
    question: "When transporting a flammable liquid in a tanker, you must ensure:",
    options: [
      "Only that the placard is correct",
      "Proper grounding/bonding during loading/unloading, no smoking or open flames nearby, engine off when loading, and vapor venting away from ignition sources",
      "Only that the tank is sealed",
      "Only that the route avoids gas stations",
    ],
    answer: 1,
    explanation: "Flammable liquid tankers require bonding/grounding to prevent static spark ignition during loading/unloading, plus all ignition source controls. Static electricity from liquid flow can ignite vapors.",
  },
  // ── TANK VEHICLE ROLLOVER ───────────────────────────────────────────────────
  {
    id: "tn028",
    question: "Statistics show that most tank vehicle rollovers happen:",
    options: [
      "On straight highway sections",
      "On curves, on and off ramps, and when changing lanes — typically because the driver takes them too fast",
      "During backing maneuvers",
      "On wet roads only",
    ],
    answer: 1,
    explanation: "The vast majority of tanker rollovers occur during turning — curves, ramps, and lane changes. Speed is the number-one factor. Reduce speed to safe levels before every curve.",
  },
  {
    id: "tn029",
    question: "The safest way to prevent a tanker rollover is to:",
    options: [
      "Load the tank to capacity to reduce surge",
      "Drive slowly enough that liquid movement does not shift the center of gravity beyond the vehicle's stability limits — always reduce speed for curves and ramps",
      "Brake hard just before the curve",
      "Drive in the left lane to have more room",
    ],
    answer: 1,
    explanation: "Speed control is the primary rollover prevention strategy. Know your vehicle's characteristics, check ramp and curve speeds posted for trucks, and slow well below the limit when necessary.",
  },
  {
    id: "tn030",
    question: "If you feel a tanker beginning to tip (initial rollover), you should:",
    options: [
      "Brake hard and steer opposite the tip",
      "There is virtually nothing you can do once a rollover starts — prevention by slowing before curves is the only effective strategy",
      "Accelerate to stabilize the vehicle",
      "Apply only the trailer brakes",
    ],
    answer: 1,
    explanation: "Once a rollover is in progress, there is essentially nothing that can stop it. The only effective strategy is prevention: reduce speed before curves, ramps, and lane changes.",
  },
  // ── FOOD GRADE TANKERS ──────────────────────────────────────────────────────
  {
    id: "tn031",
    question: "Food-grade liquid tankers (milk, juice, cooking oil) are often smooth-bore (unbaffled) because:",
    options: [
      "Smooth-bore tanks are cheaper to manufacture",
      "Baffles create areas where liquid can pool and bacteria can grow, making cleaning and sanitation difficult",
      "Smooth-bore tanks have less surge",
      "Baffles are too heavy for food products",
    ],
    answer: 1,
    explanation: "Food-grade tankers must be thoroughly cleaned and sanitized between loads. Baffles create hard-to-clean crevices. Smooth-bore tanks can be fully cleaned and inspected more easily.",
  },
  // ── TANKER PARKING AND SECURING ─────────────────────────────────────────────
  {
    id: "tn032",
    question: "When parking a loaded tanker, you should:",
    options: [
      "Only set the parking brake",
      "Set the parking brake, chock wheels, close all valves, and park on a level surface away from ignition sources if carrying flammables",
      "Leave the engine running to maintain pressure",
      "Open vents to equalize pressure before parking",
    ],
    answer: 1,
    explanation: "Proper tanker parking requires: parking brake, chocks, all valves secure, and appropriate location based on cargo type. Flammable cargo requires extra caution regarding ignition sources.",
  },
  {
    id: "tn033",
    question: "If you notice a liquid tanker is leaking during transport, you should:",
    options: [
      "Continue to the nearest truck stop",
      "Stop safely, stay upwind, keep people away, identify the material from shipping papers, and call for emergency response",
      "Try to plug the leak with rags",
      "Drive to the nearest weigh station and report it",
    ],
    answer: 1,
    explanation: "A leaking tanker is a serious emergency. Stop safely, stay upwind and away from the leak, do not attempt to handle the material without proper training and equipment, and call for professional help.",
  },
  // ── HAZMAT TANKER COMBINATION ────────────────────────────────────────────────
  {
    id: "tn034",
    question: "A driver who operates a hazmat tank vehicle needs which CDL endorsements?",
    options: [
      "N endorsement only",
      "Both N (Tank) and H (Hazmat) endorsements, plus the X endorsement covers both combined",
      "H endorsement only",
      "Only a Class A CDL — no endorsements needed",
    ],
    answer: 1,
    explanation: "Transporting hazmat in a tank vehicle requires both the N (Tank) and H (Hazmat) endorsements. The X endorsement is a combination endorsement that covers both N and H.",
  },
  {
    id: "tn035",
    question: "The X endorsement on a CDL means:",
    options: [
      "The driver is expired and the license needs renewal",
      "The driver is authorized to operate tank vehicles carrying hazardous materials — it combines the N and H endorsements",
      "The driver has extra training for oversized loads",
      "The driver is restricted to intrastate operations",
    ],
    answer: 1,
    explanation: "The X endorsement is a combination of Tank (N) and Hazmat (H) endorsements. It allows the holder to drive hazmat tank vehicles without needing separate N and H endorsements.",
  },
  // ── TANK INSPECTION SPECIFICS ────────────────────────────────────────────────
  {
    id: "tn036",
    question: "MC (Motor Carrier) specification tanks must be inspected and tested periodically. The required periodic test for most liquid tanks is called:",
    options: [
      "Annual safety inspection",
      "The 5-year retest — tanks must be pressure-tested and internally inspected at required intervals per 49 CFR",
      "Monthly pressure check",
      "The DOT 90-day check",
    ],
    answer: 1,
    explanation: "MC-specification tanks must undergo periodic retesting (often 5-year intervals for most types) that includes pressure testing, visual internal inspection, and verification of markings.",
  },
  {
    id: "tn037",
    question: "The tank specification plate on a cargo tank must show:",
    options: [
      "Only the capacity",
      "The tank manufacturer, specifications (type of tank), capacity, maximum allowable working pressure, and testing dates",
      "Only the DOT number",
      "Only the carrier name",
    ],
    answer: 1,
    explanation: "The specification plate tells inspectors and operators the tank's design limits, capacity, test history, and compliance. Carrying cargo in a tank without a current spec plate is a violation.",
  },
  {
    id: "tn038",
    question: "A driver must refuse to load a tank if:",
    options: [
      "The tank is dirty",
      "The tank is not properly tested and certified for the product, or if the tank is visibly damaged, has a missing or expired spec plate, or valves are defective",
      "The tank is less than 5 years old",
      "The previous load was a different product",
    ],
    answer: 1,
    explanation: "Operating an out-of-spec tank is illegal and dangerous. Damaged tanks, expired certifications, or missing spec plates mean the tank may not safely contain the cargo.",
  },
  // ── SPECIAL OPERATIONS ───────────────────────────────────────────────────────
  {
    id: "tn039",
    question: "When loading or unloading a flammable liquid tanker, grounding or bonding wires are used to:",
    options: [
      "Provide electrical power to the pump",
      "Prevent static electricity buildup that could ignite flammable vapors",
      "Hold the hose in place",
      "Comply with weight restrictions",
    ],
    answer: 1,
    explanation: "Flowing flammable liquid can generate static electricity. Grounding the tank and bonding it to the receiving container prevents a static spark from igniting the vapors produced during transfer.",
  },
  {
    id: "tn040",
    question: "After delivering a flammable liquid, the tank may still be dangerous because:",
    options: [
      "The tank walls retain heat",
      "Empty tanks often contain flammable vapors that are actually more explosive than the full liquid — never treat an 'empty' flammable tank as safe",
      "The pump may still contain fuel",
      "The weight is uneven after delivery",
    ],
    answer: 1,
    explanation: "Vapor-air mixtures in 'empty' tanks can be within the explosive range. This is why 'empty' flammable tankers carry the same hazmat placards as full ones — they may be more dangerous.",
  },
];

export default tanker;
